import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject } from 'rxjs';

export function trimTrailingSlash(str: string) {
  return str.replace(/\/$/, '');
}

export interface IApiService {
  getToken: () => string;
  setToken: (token: string) => void;
  getOrigin: () => string;
  setOrigin: (origin: string) => void;
}

@Injectable({ providedIn: 'root' })
export class SntApiService implements IApiService {
  readonly token$ = new BehaviorSubject<string>('');

  private _origin!: string;
  private _token!: string;

  getOrigin(): string {
    return this._origin;
  }

  setOrigin(url: string): void {
    this._origin = url;
  }

  setToken(token: string) {
    this._token = token;
    this.token$.next(token);
  }

  getToken() {
    return this._token;
  }

  isDev() {
    return this._origin.includes('.t.');
  }
}

@Injectable()
export class SntSecondaryApiService {
  protected api = inject(SntApiService);

  protected http = inject(HttpClient);
}
